/**
 * @deprecated use named exports
 */

export const selfServiceEventsURL = `${process.env.NEXT_PUBLIC_SELF_SERVICE_DASHBOAR_URL}/events`;
